import { GuidesPage } from "@/pages/Catalog";
export default GuidesPage;
